
import { useAuth } from '@/components/AuthProvider';
import { LoadingSpinner } from '@/components/ui/loading-spinner';

interface SubscriptionGuardProps {
  children: React.ReactNode;
}

export function SubscriptionGuard({ children }: SubscriptionGuardProps) {
  const { session, loading } = useAuth();

  // Show loading while checking authentication
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <LoadingSpinner />
      </div>
    );
  }

  // If user is not logged in, allow access to public content
  if (!session) {
    return <>{children}</>;
  }

  // All authenticated users now have full access (no subscription required)
  return <>{children}</>;
}
